import { hasAtLeastOneRole } from "./permissionsUtils";
export var getFallbackRoute = function (activeRoles, routes, preferredKey) {
    var isAccessible = function (route) {
        if (!route.roles)
            return true;
        if (!activeRoles)
            return false;
        return hasAtLeastOneRole(activeRoles, route.roles);
    };
    var preferred = preferredKey ? routes[preferredKey] : undefined;
    if (preferred && isAccessible(preferred)) {
        return preferred;
    }
    return Object.values(routes).find(isAccessible);
};
